import { FC } from "react";
import { KTIcon } from "../../../../../_metronic/helpers";
import { useModalAuditoriaPropiedadC } from "../providers/ModalAuditoriaPropiedadC";
import { IAPropiedadCaracteristica } from "../../../../../interfaces/auditorias/IAPropiedadCaracteristica";
import { BotonIcon } from "../../../../shared/misc/BotonOpenModal";

interface BotonTerceroContactoProps {
    tercero: IAPropiedadCaracteristica
}
export const BotonOpenModalAPC: FC<BotonTerceroContactoProps> = ({
    tercero
}) => {

    const { showModal } = useModalAuditoriaPropiedadC();

    return <BotonIcon icon="bi-eye-fill" tooltip="Ver cambios" onClick={() => showModal(true, tercero.idAuditoria)} />
}